import React from "react";
import styled from "styled-components";

const PopupOverLay = ({ style, children, isOpen, onClick }) => {
  return (
    <StyledPopupOverLay
      isOpen={isOpen}
      style={{
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </StyledPopupOverLay>
  );
};

export default PopupOverLay;

const StyledPopupOverLay = styled.div.attrs((props) => {})`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  animation: ${(props) => (props.isOpen ? "fadeIn 0.3s" : "fadeOut 0.3s")};
  transition: "background-color 0.3s";
`;
